import { render, staticRenderFns } from "./SavedTableList.vue?vue&type=template&id=0299b4b5&scoped=true&"
import script from "./SavedTableList.vue?vue&type=script&lang=js&"
export * from "./SavedTableList.vue?vue&type=script&lang=js&"
import style0 from "./SavedTableList.vue?vue&type=style&index=0&id=0299b4b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0299b4b5",
  null
  
)

export default component.exports